import React, { useEffect } from "react";
import styles from "./styles.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Banner from "../../components/Banner";
import DigitalCard from "../../components/DigitalCard";
// import Section from "../../components/tenantScreen/TanentSection";
import Section from "../../components/Section/TanentSection";
import { myList, tenantScreenData } from "./data";
const TenantScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);

  return (
    <div className={styles.mainContainer}>
      <Navbar />
      <Header
        heading=" Discover a digital rental experience through our curated platform "
        desc="Revolutionizing the way you connect with your property owner or landlord, providing a comprehensive online stay solution"
      />
      <Section
        myList={myList}
        text="It is simple and doesn’t cost you anything"
      />
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h3>
            Experience a <span>digital stay</span>
          </h3>
          <p>
            We've obtained it and customized it precisely to suit your
            requirements
          </p>
        </div>
        <div className={styles.infoContainer}>
          {tenantScreenData.map((data) => (
            <DigitalCard name={data.name} desc={data.desc} img={data.img} />
          ))}
        </div>
      </div>
      <Banner
        text="Begin your tenancy journey with us"
        backgroundColor="#550990"
      />
      <Footer />
    </div>
  );
};

export default TenantScreen;
